import { Contact } from '/@/modules/contact/models/Contact';
import { ModelHasLiability } from '/@/modules/contact/models/ModelHasLiability';
import { ModelHasLiabilityCategory } from '@/modules/contact/enums/ModelHasLiabilityCategory';

export class ContactCreditor extends Contact {
  constructor(model: Partial<ContactCreditor> = {}) {
    super(model);

    this.pivot = ModelHasLiability.mapModel({
      liabilityId: undefined,
      ...(model.pivot ?? {}),
      category: ModelHasLiabilityCategory.CREDITOR
    });
  }
}
